module.exports = __webpack_public_path__ + "6c0e306f57dd7d5cc5013f048af3c3ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-girl-blonde-s.png
// module id = 2684
// module chunks = 0